import { render, staticRenderFns } from "./BjUpload.vue?vue&type=template&id=30a758b3&scoped=true"
import script from "./BjUpload.vue?vue&type=script&lang=js"
export * from "./BjUpload.vue?vue&type=script&lang=js"
import style0 from "./BjUpload.vue?vue&type=style&index=0&id=30a758b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a758b3",
  null
  
)

export default component.exports